import { useState } from 'react';
import { isEmpty } from 'lodash-es';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons';
import { useFormValues, useSetFieldValue } from '@s20/components/forms/FormContext';
import Slideout from '../../common/Slideout';
import { UncontrolledSaveButton } from '../../common/forms/SaveButton';
import { FlexStartRow } from '../../common/forms/FormElements';
import { DraggableResourceTypes } from '../../dispatch/Dispatch';
import { Resources } from './Resources';
import { useTotalAvailableResources } from './Resources/useTotalAvailableResources.hook';
import { useAssignResourcesButton } from './Resources/useAssignResourcesButton.hook';

const ResourcesHeader = ({ selected, setSelected }) => {
    const totalAvailable = useTotalAvailableResources();
    const { handleAssignmentButtonClick, packageAssignmentData } = useAssignResourcesButton({ totalAvailable, setSelected });
    const selectedResourceType = useFormValues('selectedResourceType');

    return (
        <FlexStartRow className="mt-1 mb-2 pl-3 pr-3">
            <div className="flex-none">
                <UncontrolledSaveButton
                    color="primary"
                    className="mr-4"
                    disabled={isEmpty(selected)}
                    onClick={() => handleAssignmentButtonClick.mutateAsync(packageAssignmentData(selected))}
                    icon={faAnglesLeft}
                    label={`Assign ${selectedResourceType === DraggableResourceTypes.Staff ? 'Staff' : 'Equipment'}`}
                    savingLabel="Assigning..."
                    type="button"
                />
            </div>

            <div>
                {selected.length || 0} of {totalAvailable} selected
            </div>
        </FlexStartRow>
    );
};

export const MobileResourceLoader = () => {
    const [selected, setSelected] = useState([]);

    const selectedResourceGroup = useFormValues('selectedResourceGroup');
    const setFieldValue = useSetFieldValue();

    return (
        <Slideout
            show={!!selectedResourceGroup}
            onClose={() => setFieldValue('selectedResourceGroup', null)}
            size="col-xl-5 col-lg-6 col-md-8 col-sm-12"
            formTitle={(
                <ResourcesHeader
                    selected={selected}
                    setSelected={setSelected}
                />
            )}
        >
            <Resources
                selected={selected}
                setSelected={setSelected}
            />
        </Slideout>
    );
};